/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./reset-template.vue?vue&type=template&id=0c6bbe93&scoped=true&"
import script from "./reset-template.vue?vue&type=script&lang=js&"
export * from "./reset-template.vue?vue&type=script&lang=js&"
import style0 from "./reset-template.vue?vue&type=style&index=0&id=0c6bbe93&prod&lang=scss&scoped=true&"
import style1 from "./reset-template.vue?vue&type=style&index=1&id=0c6bbe93&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6bbe93",
  null
  
)

export default component.exports